// extracted by mini-css-extract-plugin
export default {"icon":"icon__1xJxp","dropdown":"dropdown__aCUEu","text":"text__2VLhT","bottom":"bottom__24wsK"};